import { IconProps } from 'interfaces';
import COLOR from 'constants/color';
import { isDarkMode } from 'utils/validators';

const Star = ({
  fill = COLOR.GRAY['900'],
  fillDarkMode = COLOR.WHITE,
  className = '~w-4/5 ~h-4/5'
}: IconProps) => {
  const fillColor = isDarkMode() ? fillDarkMode : fill;
  return (
    <svg
      width='40'
      height='40'
      viewBox='0 0 40 40'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
      className={className}
      preserveAspectRatio='xMidYMid meet'>
      <path
        d='M36.6673 20.0002C36.6673 10.7954 29.2053 3.3335 20.0007 3.3335C10.7959 3.3335 3.33398 10.7954 3.33398 20.0002C3.33398 29.2048 10.7959 36.6668 20.0007 36.6668C29.2053 36.6668 36.6673 29.2048 36.6673 20.0002Z'
        stroke={fillColor}
        strokeWidth='2'
      />
      <path
        d='M21.439 12.87L22.9055 15.8272C23.1055 16.2389 23.6389 16.6338 24.0887 16.7093L26.7469 17.1547C28.4467 17.4403 28.8465 18.6837 27.6217 19.9102L25.5552 21.9938C25.2054 22.3467 25.0137 23.0272 25.122 23.5143L25.7135 26.0935C26.1802 28.1352 25.1054 28.9248 23.3139 27.8578L20.8225 26.3708C20.3725 26.102 19.6309 26.102 19.1727 26.3708L16.6812 27.8578C14.8981 28.9248 13.8149 28.1267 14.2815 26.0935L14.8731 23.5143C14.9814 23.0272 14.7898 22.3467 14.4398 21.9938L12.3734 19.9102C11.1569 18.6837 11.5485 17.4403 13.2483 17.1547L15.9063 16.7093C16.348 16.6338 16.8812 16.2389 17.0812 15.8272L18.5477 12.87C19.3477 11.2653 20.6475 11.2653 21.439 12.87Z'
        fill={fillColor}
        stroke={fillColor}
        strokeWidth='2'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
    </svg>
  );
};

export default Star;
